import { useEffect } from "react";

const DEFAULT_TITLE = "Partner | apoteka.rs";
const CONSULT_TITLE = "Dolazni poziv | apoteka.rs";
const DEFAULT_FAVICON = "/favicon.svg";
const NOTIFY_FAVICON = "/favicon-notify.svg";

/**
 * Tab-level attention signals.
 *
 * @param count      pending work items (orders, RFZO requests) shown as a badge
 * @param ringing    an incoming video consult is waiting to be answered. It
 *                   takes over the title instead of joining the badge count: a
 *                   call is answered in seconds or it is lost, and a pharmacist
 *                   scanning a strip of background tabs has to be able to tell
 *                   it apart from a queue that can wait.
 */
export const useTabNotifications = (count: number, ringing = false) => {
  useEffect(() => {
    const notify = ringing || count > 0;

    // Update title
    document.title = ringing
      ? CONSULT_TITLE
      : count > 0
      ? `(${count}) ${DEFAULT_TITLE}`
      : DEFAULT_TITLE;

    // Update favicon
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "icon");
      document.head.appendChild(link);
    }

    link.setAttribute("href", notify ? NOTIFY_FAVICON : DEFAULT_FAVICON);

    return () => {
      document.title = DEFAULT_TITLE;
      if (link) {
        link.setAttribute("href", DEFAULT_FAVICON);
      }
    };
  }, [count, ringing]);
};
